//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import times from 'lodash/times';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-down.svg';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import GetMediaQuery from '~/mixins/GetMediaQuery';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph';

var GlobalTitle = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalTitle.vue');

var HEADER_SPACE = {
  mobile: 144,
  tablet: 74,
  desktop: 88,
  xlarge: 88
};
export default {
  name: 'Anchor',
  components: {
    GlobalTitle,
    SimpleParagraph
  },
  mixins: [GetMediaQuery],
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref8, _ref9;

      if (!this.payload) return {};
      return {
        titre: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? (_ref9 = _ref9.titre) != null ? _ref9[0] : _ref9 : _ref9 : _ref9) || {},
        paragraphe: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? (_ref8 = _ref8.paragraphe) != null ? (_ref8 = _ref8[0]) != null ? _ref8.text : _ref8 : _ref8 : _ref8 : _ref8) || '',
        background_color: this.payload.primary.background_color || '#FFFFFF',
        items: times(this.payload.items.length, Number).map(i => {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;

          return {
            intro: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.items) != null ? (_ref7 = _ref7[i]) != null ? (_ref7 = _ref7.intro) != null ? _ref7[0] : _ref7 : _ref7 : _ref7 : _ref7) || {},
            text: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.items) != null ? (_ref6 = _ref6[i]) != null ? (_ref6 = _ref6.text) != null ? _ref6[0] : _ref6 : _ref6 : _ref6 : _ref6) || {},
            imgSrc: formatPrismicImage((_ref5 = this.payload) != null ? (_ref5 = _ref5.items) != null ? (_ref5 = _ref5[i]) != null ? (_ref5 = _ref5.image) != null ? _ref5.url : _ref5 : _ref5 : _ref5 : _ref5) || EMPTY_PIXEL,
            anchor_name: this.payload.items[i].anchor_name,
            imgSrcset: "".concat(formatPrismicImage((_ref4 = this.payload) != null ? (_ref4 = _ref4.items) != null ? (_ref4 = _ref4[i]) != null ? (_ref4 = _ref4.image) != null ? _ref4.url : _ref4 : _ref4 : _ref4 : _ref4, ['w_375,ar_4:3,c_fill']), " 375w,\n              ").concat(formatPrismicImage((_ref3 = this.payload) != null ? (_ref3 = _ref3.items) != null ? (_ref3 = _ref3[i]) != null ? (_ref3 = _ref3.image) != null ? _ref3.url : _ref3 : _ref3 : _ref3 : _ref3, ['w_375,dpr_2,ar_4:3,c_fill']), " 750w,\n              ").concat(formatPrismicImage((_ref2 = this.payload) != null ? (_ref2 = _ref2.items) != null ? (_ref2 = _ref2[i]) != null ? (_ref2 = _ref2.image) != null ? _ref2.url : _ref2 : _ref2 : _ref2 : _ref2, ['w_1440,ar_4:3,c_fill']), " 1440w,\n              ").concat(formatPrismicImage((_ref = this.payload) != null ? (_ref = _ref.items) != null ? (_ref = _ref[i]) != null ? (_ref = _ref.image) != null ? _ref.url : _ref : _ref : _ref : _ref, ['w_1440,dpr_2,ar_4:3,c_fill']), " 2880w"),
            css_vars: {
              '--fill-color': this.payload.items[i].fill_color || '#3C3C3B',
              '--intro-color': this.payload.items[i].intro_color || '#3C3C3B'
            }
          };
        })
      };
    },

    headerSpace() {
      if (typeof window === 'undefined') {
        return null;
      }

      if (this.isMobile()) {
        return HEADER_SPACE.mobile;
      }

      if (this.isTablet()) {
        return HEADER_SPACE.tablet;
      }

      if (this.isDesktop()) {
        return HEADER_SPACE.desktop;
      }

      return HEADER_SPACE.xlarge;
    }

  },
  methods: {
    jumpTo(target) {
      var targetElement = document.querySelector("#".concat(target));

      if (!targetElement) {
        console.log('Anchor not found');
        return;
      }

      window.scrollTo({
        top: targetElement.offsetTop - this.headerSpace,
        behavior: 'smooth'
      });
    }

  }
};